import { Button, Container, Grid } from "@mui/material";
import { Box } from "@mui/system";
import homeData from "../../component/data";
import DropzoneComponent from "../../component/DropzoneComponent";
import { useEffect, useRef, useState } from "react";
import "../styles/home.scss";
import { useNavigate } from "react-router-dom";
import {
    BillreaderSection,
  ButtonGrid,
  HomeSection,
  IconItem,
  IconItems,
  IntroItem,
  IntroSection,
} from "../../component/styles/common.styled";
import { BillReader } from "../../component/bill-reader";
export const Home = () => {
  const [isPc, setIsPc] = useState(true);
  const mainRef = useRef<null | HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    getWidth();
  }, []);
  const getWidth = () => {
    let width = document.body.clientWidth;
    if (width < 1200) {
      setIsPc(false);
    }
  };

  const handleClick = () => {
    if (mainRef && mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  return (
    <div>
      <HomeSection>
        <Container>
          <h2>AI-Driven Bill Data Capture</h2>
          <Grid container>
            <Grid item sm={6}>
              <p>
                Provides unprecedented capability to capture customer bill data
                via smart phone photo scan or file upload.
              </p>
              <p style={{ fontStyle: "italic" }}>
                Powered by machine learning.
              </p>
              <ButtonGrid>
                <Button
                  variant="contained"
                  className="demo-button"
                  onClick={() => {
                    handleClick();
                  }}
                >
                  Schedule an online demo
                </Button>
                <Button
                  variant="contained"
                  className="contact-button"
                  onClick={() => {
                    navigate("/contact");
                  }}
                >
                  Contact Us
                </Button>
              </ButtonGrid>
            </Grid>
            <Grid item sm={6} pt={2}>
              <img src={require("../images/bill-v2.png")} alt="" />
            </Grid>
          </Grid>
          <p style={{ textAlign: "center" }}>
            Join these companies using billreader.com
          </p>
        </Container>
      </HomeSection>
      <Container>
        <IconItems>
          <IconItem>
            <img src={require("../images/icon1.png")} alt="" />
            <div>
              <p>Plug and play</p>
              <label>{homeData.plug_label}</label>
            </div>
          </IconItem>
          <IconItem>
            <img src={require("../images/icon2.png")} alt="" />
            <div>
              <p>Reduce errors</p>
              <label>{homeData.reduce_label}</label>
            </div>
          </IconItem>
          <IconItem>
            <img src={require("../images/icon3.png")} alt="" />
            <div>
              <p>Full technology</p>
              <label>{homeData.full_label}</label>
            </div>
          </IconItem>
          <IconItem>
            <img src={require("../images/icon4.png")} alt="" />
            <div>
              <p>Fast</p>
              <label>{homeData.fast_label}</label>
            </div>
          </IconItem>

          {!isPc && <div style={{ clear: "both" }} />}
        </IconItems>
      </Container>
      <BillreaderSection ref={mainRef}>
        <Container>
            <p className="title">Test your own bills, Now!</p>
            <p className="intro">Toggle between the demo images or upload your own and extract data live.</p>
            <BillReader />
        </Container>
      </BillreaderSection>

      <div className="mobile_upload">
        <DropzoneComponent />
      </div>
      <Container>
        <div style={{ marginBottom: "30px" }}>
          <p
            style={{
              fontSize: "2.2rem",
              textAlign: "center",
              color: "#404040",
            }}
          >
            Why choose Billreader?
          </p>
          <IntroSection>
            <IntroItem style={{ background: "#F5F5F5" }}>
              <img src={require("../images/bill_icon1.png")} alt="" />
              <p>{homeData.footer_label1}</p>
            </IntroItem>
            <IntroItem>
              <img src={require("../images/bill_icon2.png")} alt="" />
              <p>{homeData.footer_label2}</p>
            </IntroItem>
            <IntroItem>
              <img src={require("../images/bill_icon3.png")} alt="" />
              <p>{homeData.footer_label3}</p>
            </IntroItem>
            <IntroItem style={{ background: "#F5F5F5" }}>
              <img src={require("../images/bill_icon4.png")} alt="" />
              <p>{homeData.footer_label4}</p>
            </IntroItem>
          </IntroSection>
        </div>
      </Container>
    </div>
  );
};
